/**
 * Helpers
 * ------
 * General purpose helper functions for component-wide use
 */

window.helpers = {

    // Google Analytics Event (using GTM)
    gaEvent(category, action, label) {
        if (typeof ga === 'function' && typeof ga.getAll === 'function') {
            let tracker = ga.getAll()[0];
            if (tracker) tracker.send('event', category, action, label.toString());
        }
    },

    // Get Query Variable out of the URL
    getQueryVariable(variable) {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    },

    // Includes function that works in IE versions that do not support the .includes jquery function
    includes(container, value) {
        let returnValue = false;
        let pos = container.indexOf(value);
        if (pos >= 0) returnValue = true;
        return returnValue;
    },

    // Browser check
    browser() {
        // Return cached result if available, else get result then cache it.
        if (browser.prototype._cachedResult)
            return browser.prototype._cachedResult;

        // Opera 8.0+
        let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        let isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]"
        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || safari.pushNotification);

        // Internet Explorer 6-11
        let isIE = /*@cc_on!@*/false || !!document.documentMode;

        // Edge 20+
        let isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1+
        let isChrome = !!window.chrome && !!window.chrome.webstore;

        // Blink engine detection
        let isBlink = (isChrome || isOpera) && !!window.CSS;

        return browser.prototype._cachedResult =
            isOpera ? 'Opera' :
                isFirefox ? 'Firefox' :
                    isSafari ? 'Safari' :
                        isChrome ? 'Chrome' :
                            isIE ? 'IE' :
                                isEdge ? 'Edge' :
                                    isBlink ? 'Blink' :
                                        "Don't know";
    },

    currentUrl: function () {
        return window.location.href;
    },

    scrollTo: function (elem, offset, timing) {
        if (offset === undefined) { let offset = 100; }
        if (timing === undefined) { let timing = 500; }

        $('html, body').animate({
            scrollTop: (elem.offsetTop - offset)
        }, timing);
    },

	debounce: function(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},

	// https://stackoverflow.com/questions/27078285/simple-throttle-in-js
	throttle( wait, func,options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous && options.leading === false) previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    },

	isInViewport : function(el){
		var rect = el.getBoundingClientRect();
    	return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
	},

	isEscape (e) {
		// keyCode is getting deprecated use key instead when supported, which makes this messy
		var evt = e || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = (evt.key == "Escape" || evt.key == "Esc");
		} else {
			isEscape = (evt.keyCode == 27);
		}
		return isEscape;
	},

	trapFocus (elementId, focusFirst = true) {
		const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
		const trap = document.querySelector(elementId); // select the trap by it's id
		const firstFocusableElement = trap.querySelectorAll(focusableElements)[0]; // get first element to be focused inside trap
		const focusableContent = trap.querySelectorAll(focusableElements);
		const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap

		document.addEventListener('keydown', function (e) {
			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) { // if shift key pressed for shift + tab combination
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus(); // add focus for the last focusable element
					e.preventDefault();
				}
			} else { // if tab key is pressed
				if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
					firstFocusableElement.focus(); // add focus for the first focusable element
					e.preventDefault();
				}
			}
		});
		if (focusFirst) {
			setTimeout(() => {
				firstFocusableElement.focus();
			}, 350);
		}
	},

	returnFocus(){
		if (typeof window.$returnFocusTo !== 'undefined') {
			window.$returnFocusTo.focus();
		}
	}

};
